// src/components/AboutInfo.jsx
import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import kadiProfilePic from '../../../assets/img/kadi-profile.jpg';

const useStyles = makeStyles((theme) => ({
  kadiInfoContainer: {
    width: '100%',
    backgroundColor: '#f7e7b4', // Light gold background
    padding: '4rem 2rem',
    boxSizing: 'border-box',
    animation: '$fadeIn 1.2s ease-in-out',
    '@media (max-width: 1024px)': {
      padding: '2rem',
    },
    '@media (max-width: 767px)': {
      padding: '1.5rem',
    },
  },

  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },

  meetKadiContainer: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    marginBottom: '2rem',
    color: '#000',
    fontFamily: 'Roboto Condensed, sans-serif',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '1.5rem',
    },
  },

  meetText: {
    fontSize: '1.5rem',
    letterSpacing: '0.2rem',
    marginRight: '0.5rem',
    color: '#000',
    '@media (max-width: 1024px)': {
      fontSize: '1.3rem',
    },
  },

  kadiText: {
    fontSize: '4rem',
    color: '#333',
    fontWeight: 700,
    borderBottom: '3px solid #b89d46', // Metallic gold accent underline
    '@media (max-width: 1024px)': {
      fontSize: '3.2rem',
    },
    '@media (max-width: 767px)': {
      fontSize: '2.8rem',
    },
  },

  gridContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '2rem',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  kadiPicContainer: {
    textAlign: 'center',
    '@media (max-width: 1024px)': {
      marginBottom: '2rem',
    },
  },

  image: {
    width: '100%',
    maxWidth: '350px',
    height: 'auto',
    border: '6px solid white',
    borderRadius: '15px',
    boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  },

  aboutKadiContainer: {
    maxWidth: '800px',
    padding: '1rem',
    textAlign: 'justify',
    '@media (max-width: 1024px)': {
      width: '90%',
    },
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },

  aboutKadi: {
    color: '#000',
    fontFamily: 'Reem Kufi, sans-serif',
    fontSize: '1.05rem',
    lineHeight: '1.9',
    '@media (max-width: 1024px)': {
      fontSize: '1rem',
      lineHeight: '1.8',
    },
    '@media (max-width: 767px)': {
      fontSize: '1.1rem',
      lineHeight: '2',
      textAlign: 'left',
    },
  },
}));

const AboutInfo = () => {
  const classes = useStyles();

  return (
    <Container className={classes.kadiInfoContainer}>
      <div className={classes.meetKadiContainer}>
        <h4 className={classes.meetText}>MEET</h4>
        <h4 className={classes.kadiText}>Kadi</h4>
      </div>

      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={3}
        className={classes.gridContainer}
      >
        <Grid item xs={12} sm={5} className={classes.kadiPicContainer}>
          <img
            src={kadiProfilePic}
            className={classes.image}
            alt="Madam Kadiatu Sesay, owner of Kadi's Hair Gallery"
          />
        </Grid>

        <Grid item xs={12} sm={7}>
          <div className={classes.aboutKadiContainer}>
            <Typography className={classes.aboutKadi}>
              Madam Kadiatu Sesay, known as Kadi, was born in Kissy, Freetown, Sierra Leone,
              where her passion for community service began. She moved to the United States in
              1996 and continued her dedication to helping others, earning recognition for her
              philanthropic efforts.
              <br /><br />
              As a business entrepreneur, Kadi has made significant contributions to the hair
              salon and shipping industries, creating jobs and providing opportunities for both
              immigrants and Americans. Her salons are vital community hubs that offer
              internships and training for cosmetology students, particularly in partnership
              with Garfield High School in Woodbridge, Virginia.
              <br /><br />
              Kadi is also a mentor and coach, supporting young people in their career and
              educational pursuits. Her philanthropic work extends to Sierra Leone and other
              African countries, where she provides scholarships, financial aid, and educational
              resources to schools, including current initiatives in Kasiri and Calaba Town.
              <br /><br />
              Kadi's Hair Gallery, located in Northern Virginia, is not just a salon but a
              community center that embodies her commitment to excellence and service. The salon
              offers a wide range of hair and beauty services and serves as a training ground for
              aspiring cosmetologists.
              <br /><br />
              Through her business ventures and charitable work, Kadi continues to uplift and
              inspire her community, making a lasting impact both locally and abroad.
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutInfo;
